import React, { useState } from 'react';
import cn from 'classnames';
import QRCode from 'react-qr-code';
import styles from './GetAccessCode.module.scss';
import routes from '../../../routes';
import FacialRecognitionForm from './FacialRecognitionForm';
import { FailedAccessCodeAttempt } from '../../../models';

window.FailedAccessCodeAttempt = FailedAccessCodeAttempt;

export default function BadStatus({ schoolId, email, failedAttemptId }) {
  const [hasAttached, setHasAttached] = useState(false);

  const onAttach = () => setHasAttached(true);

  const onSubmit = () => window.scrollTo(0, 0);

  const onContinue = async () => {
    if (!failedAttemptId) return;

    const failedAccessCodeAttempt = new FailedAccessCodeAttempt({ id: failedAttemptId });
    failedAccessCodeAttempt.isPersisted = true;
    failedAccessCodeAttempt.status = 'processed';
    await failedAccessCodeAttempt.save();
  };

  return (
    <div className={cn(styles.container, styles.getAccessCodePage, styles.column)}>
      {!hasAttached && (
        <>
          <h3 className={cn(styles.header, styles.noAccessCode, styles.sorryHeader)}>We&apos;re sorry</h3>
          <p>We are unable to locate an Access Code for your child.</p>
          <p>
            Please take a picture of your child and attach it here.
            {' '}
            <span className={styles.notOnMobileText}>(if not on mobile)</span>
          </p>
        </>
      )}
      <FacialRecognitionForm onAttach={onAttach} onContinue={onContinue} onSubmit={onSubmit} />
      {!hasAttached && (
        <div className={cn(styles.qrCodeSection, styles.section)}>
          <p>If you would like to continue on your phone,</p>
          <p>please scan the QR code below to continue there.</p>
          <QRCode value={`https://shoobphoto.com/c${routes.mobileUpload({ schoolId, email })}`} />
        </div>
      )}
    </div>
  );
}
